<template>
<div style="height: 100%; position: relative;">
    <div id="d005" class="" style="position: absolute; top: 0; left: 0; right: 0; bottom: 40px;"></div>
    <div class="center" style="position: absolute; bottom: 0; left: 0; right: 0;">
		<span class="dot bcPrimary"></span> Tillgångar
		<span class="dot bcTertiary"></span> Skulder
		<span class="dot bcLightGrey"></span> Obeskattade reserver
		<span class="dot result"></span> Eget kapital
	</div>
</div>
</template>

<script>
    /* tslint:disable */
    import Highcharts from 'highcharts'
    import Vue from 'vue';
    import {colors} from '@/config'

    export default {
        name: "D005",
        components: {},
        props: {
            balance: Object
        },

        mounted() {
            this.chart = new Highcharts.chart({

                chart: {
                    type: 'column',
                    renderTo: 'd005',
                    backgroundColor: 'transparent',
                },

                credits: {
                    enabled: false,
                },

                title: {
                    text: ''
                },

                legend: {
                    enabled: false
                },

        		colors: [
                    ...Array(3).fill(colors.Primary),
                    ...Array(3).fill(colors.Tertiary),
                    colors.LightGrey,
                    colors.Green, 
                    colors.Red
                ],

                xAxis: {
                    categories: this.balance.sheets.map( s => s.DATE_TO.substr(0, 4) ).reverse(),
                    labels: { 
                        style: { fontSize: '1.2rem', } 
                    } 
                },

                yAxis: {
                    opposite: true,

                    allowDecimals: false,
                    title: {
                        text: ''
                    },
                    labels: {
                        formatter() { return Vue.options.filters.KR(this.value); },
                        style: { fontSize: '1.2rem', } 
                    },
                    tickPixelInterval: 150

                },

                tooltip: {
                    formatter: function () {
                        return '<b>' + this.x + '</b><br/>' +
                        this.series.name + ': ' + Vue.options.filters.TKR(this.y) + '<br/>';
                    },
                    style: { fontSize: '1.5rem', } 
                },

                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderColor: '#5d5d5d'
                    }
                },

                series: [{
                    name: 'Tecknat men ej inbetalt kapital',
                    data: this.balance.sheets.map( s => s.A ).reverse(),
                    stack: 'tillgang'
                }, {
                    name: 'Omsättningstillgångar',
                    data: this.balance.sheets.map( s => s.K ).reverse(),
                    stack: 'tillgang'
                }, {
                    name: 'Anläggningstillgångar',
                    data: this.balance.sheets.map( s => s.E ).reverse(),
                    stack: 'tillgang'
                }, {
                    name: 'Kortfristiga skulder',
                    data: this.balance.sheets.map( s => s.Q ).reverse(),
                    stack: 'skuld'
                }, {
                    name: 'Långfristiga skulder',
                    data: this.balance.sheets.map( s => s.P ).reverse(),
                    stack: 'skuld'
                }, {
                    name: 'Avsättningar',
                    data: this.balance.sheets.map( s => s.O ).reverse(),
                    stack: 'skuld'
                }, {
                    name: 'Obeskattade reserver',
                    data: this.balance.sheets.map( s => s.N ).reverse(),
                    stack: 'skuld'
                }, {
                    name: 'Eget kapital',
                    data: this.balance.sheets.map( s => s.M > 0 ? s.M : 0 ).reverse(),
                    stack: 'skuld'
                }, {
                    name: 'Negativt eget kapital',
                    data: this.balance.sheets.map( s => s.M < 0 ? s.M : 0 ).reverse(),
                    stack: 'tillgang'
                }]
            });
        },

    }
</script>

<style scoped lang="scss">
    .dot {
        height: 20px;
        width: 20px;
        border-radius: 50%;
        display: inline-block;
    }

    .result {
		background: linear-gradient( -45deg, col('colors.Red'), col('colors.Red') 50%, col('colors.Green') 50%);
        border-radius: 50%;
    }

    .center {
        font-size: 1.2rem;
    }
</style>
